// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__u0NKq","statusInfo":"styles_statusInfo__713BN","illustration":"styles_illustration__aF3ub"};